import {PhysicalAddressDto} from "./PhysicalAddressDto";
import {ClientEntityDto} from "./ClientEntityDto";
import {EnrichedDavContact} from "./VCardContactData";

export interface ContactDto extends ClientEntityDto {

    ChangeId: number | undefined;
    
    FirstName: string | null;
    MiddleName: string | null;
    LastName: string | null;

    Emails: string[];

    HasPicture: boolean;
    PictureDataUrl?: string;

    Category: string | null;

    HomePhone: string | null;
    Home2Phone: string | null;
    HomeFax: string | null;
    MobilePhone: string | null;
    BusinessPhone: string | null;
    CompanyPhone: string | null;
    Business2Phone: string | null;
    BusinessFax: string | null;
    Pager: string | null;
    RadioPhone: string | null;
    CarPhone: string | null;
    MMS: string | null;

    Addresses: PhysicalAddressDto[];
    IMAddresses: string[];

    Title: string | null;
    NickName: string | null;
    Suffix: string | null;
    Spouse: string | null;
    Children: string | null;
    WebPage: string | null;

    JobTitle: string | null;
    OfficeLocation: string | null;
    Company: string | null;
    Department: string | null;
    ManagerName: string | null;
    AssistantName: string | null;
    AssistantPhone: string | null;

    Notes: string | null;
    Birthday: string | null;
    Anniversary: string | null;

    Alias: string | null;

    CustomerId: string | null;

    GovernmentId: string | null;
}

export const blankContact: EnrichedDavContact = {
    Id: -1,
    props: {},
    Emails: [],
    DisplayName: "",
    Category: undefined,
    PhoneNumbers: [],
};
